import { ReactElement } from 'react';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const PROVIDERS_DESKTOP_COUNT = 5;

export const ProvidersDesktopSkeleton = (): ReactElement => {
  return (
    <div className="providersDesktop">
      <div className="providersDesktop__upView" style={{ padding: '0 16px' }}>
        <Skeleton.Button style={{ width: 150, height: 28 }} />
        <div
          className="providersDesktop__search"
          style={{ display: 'flex', gap: 8 }}
        >
          <Skeleton.Button style={{ minWidth: 40, width: 80, height: 40 }} />
          <Skeleton.Button style={{ width: 320, height: 40 }} />
          <Skeleton.Button style={{ minWidth: 40, width: 40, height: 40 }} />
        </div>
      </div>
      <span className="providersDesktop__border" />
      <div className="providersDesktop__downView" style={{ height: 72 }}>
        <div
          className="providersDesktop__list"
          style={{ display: 'flex', gap: 8, paddingBottom: '4px' }}
        >
          {createArray(PROVIDERS_DESKTOP_COUNT).map(provider => (
            <Skeleton.Button
              active
              key={provider}
              style={{ width: 100, height: 40 }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
